import CallError from '../../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../../utils/general';
import { envSetup } from '../setup';

/**
 * Gets available insights per envId
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to get make the request
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'appId', 'orgId', 'envId', 'deploymentId'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    envId: { allowedTypes: ['string'] },
    deploymentId: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(
    `${envSetup.endpoint}/v1/environments/${params.envId}/deployments/${params.deploymentId}/insights`,
    {
      signal,
      headers: {
        Authorization: `Bearer ${params.accessToken}`,
        'x-ims-org-id': params.orgId,
        'x-api-key': envSetup.apiKey,
        'x-app-id': params.appId,
      },
    }
  );
  let content = await response.text();

  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content.data;
  }
};
